import { shortISODateFormat } from '@app/config';

export const TIMESHEET_DATE_FORMAT = shortISODateFormat;

export const TIMESHEET_URL_PARAM_START = 'start';
export const TIMESHEET_URL_PARAM_END = 'end';
export const TIMESHEET_URL_PARAM_EMPLOYEE_ID = 'eid';
